var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsibleGambling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8103_3299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 1.15625L6.6875 3.65625C6.875 3.8125 7 4.03125 7 4.25V5.9375L10.4062 9.34375C11.3125 8.90625 12.4375 9.0625 13.1875 9.8125L16.6875 13.3125C17.0938 13.6875 17.0938 14.3438 16.6875 14.7188L14.6875 16.7188C14.3125 17.125 13.6562 17.125 13.2812 16.7188L9.78125 13.2188C9.03125 12.4688 8.875 11.3125 9.34375 10.4062L5.9375 7H4.21875C4 7 3.78125 6.90625 3.625 6.71875L1.125 3.46875C0.90625 3.15625 0.9375 2.75 1.21875 2.46875L2.46875 1.21875C2.71875 0.96875 3.15625 0.9375 3.4375 1.15625ZM1.59375 13.4062L6.25 8.75L8.1875 10.6875C8 11.3438 8.03125 12.0625 8.28125 12.7188L4.59375 16.4062C4.21875 16.7812 3.65625 17 3.09375 17C1.9375 17 1 16.0625 1 14.9062C1 14.3438 1.21875 13.7812 1.59375 13.4062ZM17 5.5C17 7.3125 15.9375 8.875 14.4062 9.59375L13.9062 9.09375C13.0312 8.21875 11.7812 7.90625 10.6562 8.21875L8 5.53125V5.5C8 3.03125 10 1 12.5 1C12.8125 1 13.125 1.0625 13.4375 1.125C13.7812 1.1875 13.875 1.625 13.625 1.875L11.625 3.875C11.5312 3.96875 11.5 4.09375 11.5 4.21875V6.03125C11.5 6.28125 11.7188 6.53125 12 6.53125H13.7812C13.9062 6.53125 14.0312 6.46875 14.125 6.375L16.125 4.375C16.375 4.125 16.8125 4.21875 16.875 4.5625C16.9375 4.875 17 5.1875 17 5.5ZM2.75 14.5C2.75 14.9375 3.0625 15.25 3.5 15.25C3.90625 15.25 4.25 14.9375 4.25 14.5C4.25 14.0938 3.90625 13.75 3.5 13.75C3.0625 13.75 2.75 14.0938 2.75 14.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8103_3299",
    x: 0.90625,
    y: 0.9375,
    width: 16.1875,
    height: 17.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8103_3299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8103_3299",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibleGambling);
export default ForwardRef;